import React from "react";
import { Popup } from "react-map-gl";
import { StyledPopup, PopupHeader, PopupTitle, PopupContent } from "../Popup/styled";

function DistrictPopup({ className, data, children, showDetails = true, showClose = true,...props }) {
  return (
    <StyledPopup className={className} {...props} $showDetails={showDetails} as={Popup}>
      <PopupHeader>
        <PopupTitle>{data.school_dis}</PopupTitle>
      </PopupHeader>
      {showDetails && (
      <PopupContent>
        <p><span>Number of Solar Schools:</span> {data.number_solar_schools}<br />
        <span>Total Solar Capacity:</span> {data.total_solar_school_energy_capacity.toLocaleString("en-US")} kW<br />
        {/* <span>Battery Storage:</span> {data.battery_storage} */}
        </p>
      </PopupContent>)}
    </StyledPopup>
  );
}

export default DistrictPopup;
